import * as EmailValidator from 'email-validator';
import { strongPasswordValidation as strongPasswordValidationUtil } from '@engenharia/mlabs-js-utils';
import { DEFAULT_COUNTRY } from './countryCodes';

const requiredValitidation = (value) => {
  if (value.length === 0) {
    return true;
  }
  return false;
};

const mailValidation = (value) => {
  if (value.length === 0) {
    return {
      emailInvalidError: false,
      emailRequiredError: true,
    };
  }

  if (!EmailValidator.validate(value)) {
    return {
      emailInvalidError: true,
      emailRequiredError: false,
    };
  }

  return {
    emailInvalidError: false,
    emailRequiredError: false,
  };
};

const strongPasswordValidation = (value) => {
  const validation = value && strongPasswordValidationUtil(value);

  return {
    passwordInvalidError: validation?.error,
    passwordMinLengthError: !validation?.hasMinLength,
    passwordUppercaseError: !validation?.hasUpperCase,
    passwordNumberError: !validation?.hasNumber,
    passwordSpecialError: !validation?.hasSpecial,
  };
};

const passwordValidation = (value) => {
  const passwordExp = /^$|.{6,}/;

  if (!passwordExp.test(value)) {
    return { passwordInvalidError: true };
  }
  return { passwordInvalidError: false };
};

const confirmPasswordValidation = (confirm, value) => {
  if (confirm === value) {
    return false;
  }
  return true;
};

const isPhoneInvalid = (phone, countryCode = DEFAULT_COUNTRY) => {
  const minLength = countryCode === DEFAULT_COUNTRY ? 10 : 5;
  const maxLength = countryCode === DEFAULT_COUNTRY ? 11 : 20;
  return phone && (phone.length < minLength || phone.length > maxLength);
};

const phoneValidation = (phone, countryCode = DEFAULT_COUNTRY) => ({
  phoneInvalidError: isPhoneInvalid(phone, countryCode),
});

export {
  requiredValitidation,
  passwordValidation,
  strongPasswordValidation,
  confirmPasswordValidation,
  mailValidation,
  isPhoneInvalid,
  phoneValidation,
};
